import { SelectionChangedEvent } from "ag-grid-community";
import { INITIAL_TRANSFER_OF_CHARGE_COL_DEF, transferRowData } from "presentation/constant/TransferOfCharge/TransferOfChargeColumnDefinition";
import { useTransferOfChargeVM } from "presentation/hook/TransferOfCharge/useTransferOfChargeVM";
import { useTransferOfChargeTracked } from "presentation/store/TransferOfCharge/TransferOfChargeProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";


const TransferOfChargeTablePanel: React.FC = () => {
    const [transferOfChargeState] = useTransferOfChargeTracked();
    const transferOfChargeVM = useTransferOfChargeVM();
    const gridRef: any = useRef(null);
    const { transferOfChargeList } = transferOfChargeState;
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    useEffect(() => {
        setShowOverlay(transferOfChargeState.isSearchLoading || (!transferOfChargeState.isSearchLoading &&
            transferOfChargeList && transferOfChargeList.length) ? false : true);

        if (gridRef.current?.gridRef.current && !transferOfChargeState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [transferOfChargeState.isSearchLoading, transferOfChargeList]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();

        transferOfChargeVM.updateSelectedRows(selectedRows);
    }, [transferOfChargeVM])



    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='transfer-of-charge-table'
                isNewColumnSetting={true}
                columns={INITIAL_TRANSFER_OF_CHARGE_COL_DEF?.slice()}
                data={transferRowData(transferOfChargeList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
            />
        );
    }, [transferOfChargeList, handleSelectionChange, showOverlay])

    return <>
        <TableWrapper>
            {memoTable}
        </TableWrapper>
    </>;
}

export default memo(TransferOfChargeTablePanel);
